import React, { useState } from 'react';
import { Col } from '../../../lib/utils';
import { Body3Regular, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

const MAX_LENGTH = 300;

const FeedTextContent = ({ textObject }: any) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const fullText = textObject[0]?.content || '';
    const isLong = fullText.length > MAX_LENGTH;
    const displayText = isExpanded || !isLong ? fullText : fullText.slice(0, MAX_LENGTH) + '...';

    return (
        <Col style={{ width: 714, alignSelf: 'center', marginTop: 16, flexWrap: 'wrap' }}>
            <Body3Regular style={{ color: colors.LAVEL_3, whiteSpace: 'pre-wrap' }}>{displayText}</Body3Regular>
            {isLong && (
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsExpanded(!isExpanded);
                    }}
                    className="mt-[8px] self-start cursor-pointer"
                >
                    <CaptionRegular style={{ color: colors.primary }}>
                        {isExpanded ? '접기 ▲' : '더보기 ▼'}
                    </CaptionRegular>
                </button>
            )}
        </Col>
    );
};

export default FeedTextContent;
